import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "ph-tabs-nav"
}
const _hoisted_2 = {
  class: "nav nav-tabs",
  id: "nav-tab",
  role: "tablist"
}
const _hoisted_3 = ["id", "onClick"]

import { PropType } from 'vue'
    import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
    import { PreHangSelections as PhSelections } from "@/services/prehang-classes/ph-selections";

    
export default /*#__PURE__*/_defineComponent({
  __name: 'PreHangTabs',
  props: {
        prehangs: { type: Array as PropType<PhSelections[]>, required: true },
        activeTab: { type: Number, required: true, default: 0 }
    },
  emits: ['changeTab', 'newTab'],
  setup(__props, { emit: emits }) {

const props = __props

    

    

return (_ctx: any,_cache: any) => {
  return (props.prehangs.length > 0)
    ? (_openBlock(), _createElementBlock("nav", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.prehangs, (ph, index) => {
            return (_openBlock(), _createElementBlock("button", {
              key: index,
              type: "button",
              role: "tab",
              id: `nav-${index}`,
              class: _normalizeClass(`nav-link ${index === props.activeTab ? 'active' : ''}`),
              onClick: () => emits('changeTab', index)
            }, [
              _createElementVNode("span", {
                class: _normalizeClass({'hasError': ph.errors.length > 0, 'isEmpty': ph.isEmpty})
              }, _toDisplayString(index + 1), 3)
            ], 10, _hoisted_3))
          }), 128)),
          (props.prehangs.length < 8)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                class: "nav-link",
                type: "button",
                onClick: _cache[0] || (_cache[0] = () => emits('newTab'))
              }, [
                _createVNode(_unref(FontAwesomeIcon), { icon: "plus" })
              ]))
            : _createCommentVNode("", true)
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})